import { gql } from "lib/apolloClient";
import {
  gradeFragment,
  unitPlanFragment,
  curriculumProgramFragment,
} from "./Fragments";

export const getStaffGradesQuery = gql`
  query getStaffGrades(
    $id: ID!
    $filters: AllGradesFilters!
    $academicYears: [ID!]
  ) {
    node(id: $id, type: STAFF) {
      id
      ... on Staff {
        id
        allGrades(filters: $filters) {
          unitPlanCount(academicYears: $academicYears)
          curriculumProgram {
            ...curriculumProgramBasicDetailsItem
          }
          ...gradeItem
        }
      }
    }
  }
  ${curriculumProgramFragment.curriculumProgramBasicDetails}
  ${gradeFragment.basicGradeDetails}
`;

export const getOrganizationGradesQuery = gql`
  query getOrganizationGrades(
    $id: ID!
    $filters: GradeFilterInput!
    $academicYears: [ID!]
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        grades(filters: $filters) {
          unitPlanCount(academicYears: $academicYears)
          curriculumProgram {
            ...curriculumProgramBasicDetailsItem
          }
          ...gradeItem
        }
      }
    }
  }
  ${curriculumProgramFragment.curriculumProgramBasicDetails}
  ${gradeFragment.basicGradeDetails}
`;

export const getUnitPlanFeedQuery = gql`
  query getUnitPlanFeed(
    $id: ID!
    $filters: UnitPlansV2FeedFilters!
    $getUnitFlowId: Boolean!
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        unitPlansV2(filters: $filters) {
          totalCount
          edges {
            node {
              ...unitPlanItem
            }
          }
        }
      }
    }
  }
  ${unitPlanFragment.unitPlanDetails}
`;

export const getOrganizationSubjectsQuery = gql`
  query getOrganizationSubjects($id: ID!, $filters: SubjectFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        subjects(filters: $filters) {
          id
          name
        }
      }
    }
  }
`;

export const getOrganizationStaffQuery = gql`
  query getOrganizationStaff($id: ID!, $filters: OrgConnectionFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        staff(filters: $filters) {
          totalCount
          edges {
            node {
              id
              firstName
              middleName
              lastName
            }
          }
        }
      }
    }
  }
`;

export const getStaffCoursesQuery = gql`
  query getStaffCourses($id: ID!, $filters: CourseFilter) {
    node(id: $id, type: STAFF) {
      ... on Staff {
        id
        coursesV2(filters: $filters) {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
`;

export const getOrganizationCoursesQuery = gql`
  query getOrganizationCourses($id: ID!, $filters: CourseFilterInput) {
    node(id: $id, type: ORGANIZATION) {
      ... on Organization {
        id
        courses(filters: $filters) {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
`;
